import React from 'react';
import { AwardIcon, CheckIcon, UserIcon, TargetIcon, EyeIcon, GraduationCapIcon, UsersIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const About = () => {
  return <div className="w-full" data-id="element-132">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-133">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-134"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-135">
          <h1 className="text-white font-bold mb-4" data-id="element-136">About Magnavera Group</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-137">
            Learn about our story, our values, and the people behind our
            success.
          </p>
        </div>
      </section>
      {/* Who We Are */}
      <section className="py-16" data-id="element-138">
        <div className="container mx-auto px-4" data-id="element-139">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-140">
            <div data-id="element-141">
              <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Magnavera Team" className="rounded-lg shadow-lg w-full" data-id="element-142" />
            </div>
            <div data-id="element-143">
              <span className="inline-block text-primary font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-144">
                Who We Are
              </span>
              <h2 className="font-bold mb-6" data-id="element-145">Our Story</h2>
              <p className="text-text-secondary mb-6 leading-relaxed" data-id="element-146">
                Magnavera Group is a financial advisory practice dedicated to
                empowering individuals and families with trusted guidance,
                lifelong education, and innovative wealth solutions.
              </p>
              <p className="text-text-secondary mb-6 leading-relaxed" data-id="element-147">
                Founded with a passion for helping clients achieve financial
                freedom, we've built our practice on the pillars of education,
                ethics, and empowerment. Our team of experienced advisors works
                tirelessly to ensure each client receives personalized attention
                and strategies tailored to their unique needs.
              </p>
              <p className="text-text-secondary leading-relaxed" data-id="element-148">
                Today, we continue to grow our practice while maintaining our
                core commitment to putting clients first and fostering long-term
                relationships built on trust and mutual success.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Mission & Vision */}
      <section className="py-16 bg-background" data-id="element-149">
        <div className="container mx-auto px-4" data-id="element-150">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-151">
            {/* Mission */}
            <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-152">
              <div className="bg-primary/10 p-4 rounded-full inline-block mb-6" data-id="element-153">
                <TargetIcon size={32} className="text-primary" data-id="element-154" />
              </div>
              <h2 className="font-bold mb-6" data-id="element-155">Our Mission</h2>
              <p className="text-text-secondary leading-relaxed" data-id="element-156">
                Our mission is to empower individuals through education, forging
                a path towards financial freedom, while upholding high standards
                of ethics. We strive to cultivate a community where integrity,
                skills and knowledge intersect, enabling individuals to make
                informed decisions and achieve their financial goals with
                confidence.
              </p>
            </div>
            {/* Vision */}
            <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-157">
              <div className="bg-primary/10 p-4 rounded-full inline-block mb-6" data-id="element-158">
                <EyeIcon size={32} className="text-primary" data-id="element-159" />
              </div>
              <h2 className="font-bold mb-6" data-id="element-160">Our Vision</h2>
              <p className="text-text-secondary leading-relaxed" data-id="element-161">
                To be the most trusted and client-focused financial advisory
                group, empowering individuals and communities through
                transparent guidance, lifelong education, and unparalleled
                service, while fostering a culture of growth, innovation, and
                social responsibility.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Culture */}
      <section className="py-16" data-id="element-162">
        <div className="container mx-auto px-4" data-id="element-163">
          <div className="text-center mb-12" data-id="element-164">
            <span className="inline-block text-primary font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-165">
              Our Culture
            </span>
            <h2 className="font-bold mb-4" data-id="element-166">What Defines Us</h2>
            <div className="w-20 h-1 bg-primary mx-auto" data-id="element-167"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-168">
            {[{
            icon: <GraduationCapIcon size={32} className="text-primary" data-id="element-169" />,
            title: 'Growth Through Mentorship',
            description: 'We foster growth through mentorship and lifelong learning, ensuring our team members continuously develop their skills and knowledge.'
          }, {
            icon: <AwardIcon size={32} className="text-primary" data-id="element-170" />,
            title: 'Celebrating Achievement',
            description: 'We recognize and celebrate achievements like MDRT qualifications, leadership conferment, and team milestones that mark our collective success.'
          }, {
            icon: <UsersIcon size={32} className="text-primary" data-id="element-171" />,
            title: 'Integrity and Service',
            description: 'We uphold integrity and service as our foundation, ensuring every client interaction reflects our commitment to ethical practices and exceptional care.'
          }].map((item, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-lg text-center" data-id="element-172">
                <div className="bg-primary/10 p-4 rounded-full inline-block mb-6" data-id="element-173">
                  {item.icon}
                </div>
                <h3 className="font-bold mb-4 text-xl" data-id="element-174">{item.title}</h3>
                <p className="text-text-secondary" data-id="element-175">{item.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Values & Awards */}
      <section className="py-16 bg-background" data-id="element-176">
        <div className="container mx-auto px-4" data-id="element-177">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-178">
            {/* Values */}
            <div data-id="element-179">
              <h2 className="font-bold mb-6" data-id="element-180">Our Values</h2>
              <ul className="space-y-4" data-id="element-181">
                {["Client-First Approach: We always prioritize what's best for you, not what's most profitable for us.", 'Transparency: We explain all details clearly so you fully understand your coverage and options.', 'Expertise: Our advisors undergo continuous education to stay at the forefront of industry developments.', 'Integrity: We build lasting relationships based on trust and ethical business practices.', "Accessibility: We're available when you need us, especially during challenging times."].map((value, index) => <li key={index} className="flex" data-id="element-182">
                    <CheckIcon className="text-primary flex-shrink-0 mr-3 mt-1" size={20} data-id="element-183" />
                    <span data-id="element-184">{value}</span>
                  </li>)}
              </ul>
            </div>
            {/* Awards */}
            <div data-id="element-185">
              <h2 className="font-bold mb-6" data-id="element-186">Awards & Recognition</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-187">
                {[1, 2, 3, 4, 5, 6].map(item => <div key={item} className="bg-white p-4 rounded-lg shadow-card text-center" data-id="element-188">
                    <AwardIcon className="text-primary mx-auto mb-2" size={32} data-id="element-189" />
                    <p className="font-semibold text-sm" data-id="element-190">
                      MDRT Qualification {2015 + item}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Meet the Team */}
      <section className="py-16" data-id="element-191">
        <div className="container mx-auto px-4" data-id="element-192">
          <h2 className="text-center font-bold mb-12" data-id="element-193">Meet Our Team</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-194">
            {[{
            name: 'John Magnavera',
            title: 'Founder & CEO',
            image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            name: 'Sarah Williams',
            title: 'Chief Advisory Officer',
            image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            name: 'Michael Chen',
            title: 'Senior Financial Advisor',
            image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            name: 'Lisa Johnson',
            title: 'Client Relations Manager',
            image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            name: 'Robert Davis',
            title: 'Wealth Management Specialist',
            image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            name: 'Jennifer Lopez',
            title: 'Estate Planning Advisor',
            image: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }].map((member, index) => <div key={index} className="bg-white rounded-lg shadow-card overflow-hidden" data-id="element-195">
                <img src={member.image} alt={member.name} className="w-full h-64 object-cover" data-id="element-196" />
                <div className="p-4" data-id="element-197">
                  <h3 className="font-bold mb-1" data-id="element-198">{member.name}</h3>
                  <p className="text-text-secondary mb-3" data-id="element-199">{member.title}</p>
                  <a href="#" className="text-primary inline-flex items-center font-semibold text-sm" data-id="element-200">
                    <UserIcon size={16} className="mr-1" data-id="element-201" />
                    LinkedIn
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Join Us CTA */}
      <section className="py-16 bg-primary text-white" data-id="element-202">
        <div className="container mx-auto px-4 text-center" data-id="element-203">
          <h2 className="font-bold mb-6" data-id="element-204">Join Our Growing Team</h2>
          <p className="max-w-2xl mx-auto mb-8 opacity-90" data-id="element-205">
            Looking for a rewarding career in financial services? We're always
            seeking talented individuals who share our passion for helping
            others achieve financial freedom.
          </p>
          <Button href="/careers" variant="secondary" className="bg-white hover:bg-gray-100 text-primary" data-id="element-206">
            Explore Career Opportunities
          </Button>
        </div>
      </section>
    </div>;
};
export default About;